import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { HighchartsChartComponent } from 'highcharts-angular';
// import { HighchartsChartModule } from 'highcharts-angular';
// import { ShareButtonsModule } from 'ngx-sharebuttons';
import { NgApexchartsModule } from 'ng-apexcharts';

import { FooterComponent } from './footer/footer.component';
import {
  NgbDatepickerModule,
  NgbDropdownModule,
  NgbModule,
  NgbPaginationModule,
  NgbTooltipModule,
  NgbTypeaheadModule,
  NgbNavModule,
} from '@ng-bootstrap/ng-bootstrap';

import { SafePipe } from './safe/safe.pipe';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// import { ngxLoadingAnimationTypes, NgxLoadingModule } from 'ngx-loading';

import { AppAccessibilityPanelComponent } from '../app-accessibility-panel/app-accessibility-panel.component';

import { MatChipsModule } from '@angular/material/chips';
import { MatSliderModule } from '@angular/material/slider';
import { TagInputModule } from 'ngx-chips';
import { GlobalLoaderComponent } from './global-loader/global-loader.component';

// const ngxLoadingPayload = {
//   animationType: ngxLoadingAnimationTypes.threeBounce,
//   backdropBackgroundColour: 'rgba(0,0,0,0.3)',
//   backdropBorderRadius: '8px',
//   primaryColour: '#114D84',
//   secondaryColour: '#114D84',
//   tertiaryColour: '#114D84',
//   fullScreenBackdrop: true,
// };

@NgModule({
  declarations: [
    HeaderComponent,
    AppAccessibilityPanelComponent,
    FooterComponent,
    SafePipe,
    GlobalLoaderComponent
  ],

  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    HighchartsChartComponent,
    NgApexchartsModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    NgbModule,
    NgbPaginationModule,
    NgbTooltipModule,
    NgbTypeaheadModule,
    NgbNavModule,
    TagInputModule,
    NgxSpinnerModule,
    NgxPaginationModule,
    NgbAccordionModule,
    MatChipsModule,
    MatSliderModule,
    // MatProgressSpinnerModule,
    
    // NgxLoadingModule.forRoot(ngxLoadingPayload),
    
    // ShareButtonsModule,
  ],

  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
TagInputModule,
    HeaderComponent,
    AppAccessibilityPanelComponent,
    FooterComponent,
    SafePipe,
    GlobalLoaderComponent,
    // MatProgressSpinnerModule,
    HighchartsChartComponent,
    NgApexchartsModule,

    NgbDatepickerModule,
    NgbDropdownModule,
    NgbModule,
    NgbPaginationModule,
    NgbTooltipModule,
    NgbTypeaheadModule,
    NgbNavModule,
    NgxSpinnerModule,
    NgxPaginationModule,
    MatChipsModule,
    MatSliderModule,

    // NgxLoadingModule,
    NgbAccordionModule
  ],

  providers: [ DatePipe ],

})
export class SharedModule {}